/**
 * CUÁNTOS ASIENTOS CABEN EN UN PDF FISCAL — fuente única, ISOMÓRFICA.
 *
 * ⚠️⚠️ POR QUÉ EXISTE (#2230). «Descargar PDF» sobre un informe de 64.087
 * asientos MATABA el proceso del backend: 1,64 GB en reposo → 7,44 GB en 30 s →
 * `FATAL ERROR: Reached heap limit`. Caía el servidor entero, con las sesiones
 * de todos los inquilinos, y lo provocaba cualquier usuario autenticado pulsando
 * un botón que estaba ahí, habilitado, junto a tres que sí funcionan.
 *
 * La causa de la explosión de memoria está arreglada en el constructor del PDF
 * (`pdf-tax-event-label-catalogue.ts`): el mismo informe construye ahora su
 * documento en 487 MB de montón en vez de reventar 8 GB. Pero eso no lo hace
 * DESCARGABLE: el renderizador sigue sin poder digerir el HTML que sale.
 *
 * ⚠️ EL TOPE NO ESTÁ ESCRITO A MANO: sale de dividir lo que el renderizador
 * aguanta entre lo que cuesta un asiento. Las dos cifras son MEDIDAS, y están
 * abajo con los informes reales de los que salen. Si el renderizador o la
 * plantilla cambian, se vuelven a medir esas dos y el tope se mueve solo.
 *
 * Lo leen los DOS lados: el backend para NEGAR la descarga antes de tocar una
 * sola fila, y el frontend para no ofrecer un botón que va a fallar. Vive aquí
 * para que no puedan discrepar.
 */

/**
 * Bytes de HTML que aporta CADA asiento al documento. MEDIDO el 2026-09-12
 * sobre cuatro informes reales de `bat_dev`, plantilla ES/full-report:
 *
 *      8.130 asientos →  3.328.647 B → 409 B/asiento
 *      9.588 asientos →  3.904.932 B → 407 B/asiento
 *     21.820 asientos →  8.828.935 B → 405 B/asiento
 *     64.087 asientos → 24.488.798 B → 382 B/asiento
 *
 * Se toma el MAYOR de los cuatro: así el presupuesto de abajo nunca se queda
 * corto por haber estimado un asiento más barato de lo que es.
 */
export const TAX_REPORT_PDF_HTML_BYTES_PER_CALCULATION = 409

/**
 * Cuánto HTML puede DIGERIR el renderizador. MEDIDO el mismo día, con el mismo
 * Chromium y el mismo tope de 30 s que `puppeteer-renderer.service.ts` le da a
 * `page.setContent`:
 *
 *     3,33 MB de HTML → PDF de 22 MB en 21,7 s            ✓
 *     3,90 MB de HTML → PDF de 26 MB en 32,0 s            ✓
 *     8,83 MB de HTML → `setContent` AGOTA los 30 s       ✗
 *    24,49 MB de HTML → `setContent` AGOTA los 30 s       ✗
 *
 * 4 MB es el escalón inmediatamente por encima del mayor tamaño que SÍ se
 * renderizó, y menos de la mitad del menor que falló. Subirlo sin volver a medir
 * devuelve el botón que no funciona; lo que ya funcionaba sigue funcionando.
 */
export const TAX_REPORT_PDF_RENDERABLE_HTML_BYTES = 4_000_000

/**
 * El tope de asientos, DERIVADO de las dos medidas anteriores.
 *
 * 4.000.000 / 409 = 9.779 asientos. Por encima de eso el PDF no se intenta: se
 * responde 422 `TAX_REPORT_PDF_TOO_LARGE` y se ofrecen el Excel y el CSV, que
 * para el MISMO informe de 64.087 asientos salen en 16,5 s sin despeinarse.
 */
export const MAX_TAX_REPORT_CALCULATIONS_FOR_PDF = Math.floor(
  TAX_REPORT_PDF_RENDERABLE_HTML_BYTES / TAX_REPORT_PDF_HTML_BYTES_PER_CALCULATION,
)

/** ¿Cabe este informe en un PDF? `true` ⇒ se puede intentar renderizarlo. */
export function isTaxReportRenderableAsPdf(calculationCount: number): boolean {
  return calculationCount <= MAX_TAX_REPORT_CALCULATIONS_FOR_PDF
}
